export default class {
  constructor() {
    this.apiKey = window.App.googleMapsApiKey;
    this.selector = '.js-map';
    this.mapOptions = {
      zoom: 15,
      disableDefaultUI: false,
      styles: [
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#f54444"
            }
          ]
        }
      ],
    };
  }

  init() {
    if (!document.querySelectorAll('.js-map').length) {
      return;
    }

    import('google-maps-api-loader').then((module) => {
      const GoogleMapsApiLoader = module.default;

      GoogleMapsApiLoader({
        libraries: ['places'],
        apiKey: this.apiKey,
      }).then(() => {
        this.google = window.google;

        [...document.querySelectorAll(this.selector)].forEach((element) => {
          this.render(element);
        });
      }, (err) => {
        // eslint-disable-next-line
        console.error(err);
      });
    });
  }

  render(el) {
    const markers = el.querySelectorAll('.marker');

    const args = Object.assign({}, this.mapOptions);
    args.mapTypeId = this.google.maps.MapTypeId.ROADMAP;

    const zoom = $(el).data('zoom');

    if (zoom) {
      args.zoom = parseInt(zoom);
    }

    const map = new this.google.maps.Map(el, args);
    map.markers = [];

    [...markers].forEach((marker) => {
      this.addMarker(marker, map);
    });

    this.centerMap(map);

    this.google.maps.event.addDomListener(window, 'resize', () => {
      this.google.maps.event.trigger(map, 'resize');
      this.centerMap(map);
    });

    return map;
  }

  addMarker(data, map) {
    const marker = new this.google.maps.Marker({
      position: {
        lat: parseFloat(data.dataset.lat),
        lng: parseFloat(data.dataset.lng),
      },
      animation: this.google.maps.Animation.DROP,
      icon: {
        url: data.dataset.marker ? data.dataset.marker : '',
        size: new this.google.maps.Size(36, 54),
        anchor: new this.google.maps.Point(18, 54),
        scaledSize: new this.google.maps.Size(36, 54),
      },
      optimized: false,
      map,
    });
    map.markers.push(marker);
  }

  centerMap(map) {
    const bounds = new this.google.maps.LatLngBounds();

    map.markers.forEach((marker) => {
      bounds.extend(new this.google.maps.LatLng(marker.position.lat(), marker.position.lng()));
    });

    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());
    } else {
      map.fitBounds(bounds);
    }
  }
}
